<app-header></app-header>
<div class="content small-head">
  <mat-card appearance="outlined" class="info-card">
    <h3>{{ "PutIdentifyData" | translate }}</h3>
    @if (bookTypeFr) {
      <div>
        <app-userdataformfr></app-userdataformfr>
      </div>
    } @else {
      @if (bookTypeKbw) {
        <div>
          <app-userdataformkbw></app-userdataformkbw>
        </div>
      } @else {
        <app-userdataform></app-userdataform>
      }
    }
  </mat-card>
</div>
